







































































































import {Component, Mixins} from "vue-property-decorator";
import {namespace} from "vuex-class";
import NumberGenerator from "@/common/mixins/numberGenerator";
import QDetailModal from "@/components/qDetailModal.vue";
import Order from "../../model/order";
import Menu from "@/model/menu";
import Table from "@/model/table";
import store from "@/store";
import $ from "jquery";
import tableApi from "@/api/tableApi";
import itemApi from "@/api/itemApi";

const orderStore = namespace("OrderStore")

@Component({
  name: "OrderComponent",
  components: {QDetailModal},
})
export default class OrderComponent extends Mixins(NumberGenerator) {
  @orderStore.Getter
  getOrderList!: Order[];

  public menuRecommendedList: Menu[] = null;
  public orderList: Order[] = null;
  public table = new Table();
  public elapsedMinute = 0;
  public limitAlertTime = "0";
  public active = false;
  public recommendation = new Menu();
  public isOrder = false;

  created() {
    // todo: will update clear when unSub server.
    window.addEventListener('beforeunload', function() {
      store.dispatch('OrderStore/clearList');
    })
  }

  async mounted() {
    this.menuRecommendedList = await itemApi.getRecommendedList()
    this.menuRecommendedList.sort((a,b) => (a.ranking > b.ranking ? -1 : 1))
    this.orderList = this.getOrderList
    this.table = await tableApi.getCurrently()
    this.elapsedMinute = this.table.getElapsedMinute()
    this.limitAlertTime = this.table.getLimitAlertTime()
    this.getSuggestRecommendation()
  }

  public toggleOrderList() {
    this.active = !this.active
    $('.js__menu-list').slideToggle();
  }

  private async getSuggestRecommendation() {
    let quantityCheck = 0
    this.menuRecommendedList.map(value => {
      if (value.anotherShowMinuteFrom <= this.elapsedMinute && value.anotherShowMinuteTo >= this.elapsedMinute && value.soldOut === false) {
        quantityCheck++
        this.recommendation = value;
      }
    })

    if (quantityCheck > 0) {
      const recommendedList: Menu[] = [];
      this.menuRecommendedList.map(menu => {
        if (menu.soldOut === false) {
          recommendedList.push(menu)
        }
      })

      this.recommendation = recommendedList[Math.floor(Math.random()*recommendedList.length)]
    }
  }

  public addQuantity() {
    this.recommendation.quantity++;
  }

  public subQuantity() {
    this.recommendation.quantity--;
  }

  public isDisableStatus() {
    return this.recommendation.quantity === 0;
  }

  public openMenuDetail(menu, isEdit = false) {
    this.detailModal(menu, isEdit);
  }

  public detailModal(menu, isEdit) {
    (this.$refs.qDetailModal as QDetailModal).show(menu, isEdit);
  }

  public getTotalQuantity() {
    let totalQuantity = 0;
    if (this.orderList === null) {
      return totalQuantity
    } else {
      this.orderList.map(value => {
        totalQuantity += value.getQuantity()
      })
    }

    return totalQuantity
  }

  public getTotalPrice() {
    let totalPrice = 0;
    if (this.orderList === null) {
      return totalPrice
    } else {
      this.orderList.map(value => {
        totalPrice += value.getQuantity() * value.price
      })
    }

    return this.getPriceFormat(totalPrice)
  }

  async submitOrder() {
    // reset all Store Module
    this.orderList.map((order, key) => {
      console.log(key)
      store.dispatch('OrderStore/clearList')
      if (order.options.length > 0) {
        order.options.map(option => {
          option.quality = 0
          store.dispatch('OptionStore/editOptionToList', option)
        })
      }
    })

    this.orderList = []

    store.dispatch('MenuStore/clearList');
    store.dispatch('OptionStore/clearList');
    store.dispatch('MenuSetStore/clearList');
    store.dispatch('SetMenuItemStore/clearList');

    this.isOrder = true;
    await this.sleep(5 * 1000)
    this.isOrder = false;

    if (this.active === true) {
      this.active = false;
      $('.js__menu-list').slideToggle();
    }
  }

  async sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}
